export const getCurrentUri = () => {
  if (typeof location !== 'undefined' && typeof location.href === 'string') {
    return location.href.replace(/^[0-9a-z]+:\/\/[^\/]+/, '');
  }
  return '';
};
